import React from "react";
import { Table } from "react-bootstrap";
import { NUMBER_FORMATS } from "../../../constants/app-constant";
import {
  getCommaSeparatedNumbers,
  getCommaSeparatedNumbersInLocaleFormat,
} from "../../../utility/common-methods";
const AuthorCreatedChart = ({
  chartTitle,
  data,
  onEntityClick,
  isEmbededWidget,
  entityList,
}) => {
  const handleCountClick = (e, legend, label, from_username, channelType) => {
    try {
      let routeParams = {
        entityId: null,
        vertical: null,
        date: null,
      };
      let clickedEntity = label;

      let entity =
        entityList &&
        entityList.filter(
          (elm) =>
            clickedEntity == elm.entity_display_name?.trim() ||
            clickedEntity == elm.name || label == elm.entity_name?.trim()
        )[0];
      routeParams.entityId = entity && entity.id.toString();
      routeParams.from_username = from_username;
      routeParams.channel_type = [channelType];
      onEntityClick(e, routeParams);
    } catch (e) {
      onEntityClick(e, {});
    }
  };
  const convertToInternationalCurrencySystem = (labelValue) => {
    if (!labelValue) return "NA";
    // Nine Zeroes for Billions
    return Math.abs(Number(labelValue)) >= 1.0e9
      ? (Math.abs(Number(labelValue)) / 1.0e9).toFixed(2) + "B"
      : // Six Zeroes for Millions
      Math.abs(Number(labelValue)) >= 1.0e6
      ? (Math.abs(Number(labelValue)) / 1.0e6).toFixed(2) + "M"
      : // Three Zeroes for Thousands
      Math.abs(Number(labelValue)) >= 1.0e3
      ? (Math.abs(Number(labelValue)) / 1.0e3).toFixed(2) + "K"
      : Math.abs(Number(labelValue));
  };
  return (
    <div className="customTableWrap">
      <div className="widgetHeading">
        <label>Author Created</label>
      </div>
      <div className="table-responsive">
        <Table className="table table-chart table-sm table-bordered customTable">
          {data && data.length && (
            <thead>
              <tr>
                <th className="col">Author Name</th>
                <th className="col">Topic</th>
                <th className="col">Count</th>
              </tr>
            </thead>
          )}
          <tbody>
            {Array.isArray(data) &&
              data.map((item, index) => {
                if (!item) {
                  return null;
                }
                const {
                  topic_name,
                  profile_name,
                  count,
                } = item || {};
                return (
                  <>
                    <tr key={index}>
                      <td>
                        <strong>{profile_name}</strong>
                      </td>
                      <td>
                        <strong>{topic_name}</strong>
                      </td>
                      <td>
                        {convertToInternationalCurrencySystem(count)}
                      </td>
                    </tr>
                  </>
                );
              })}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default AuthorCreatedChart;
